"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _index = require("../utils/index");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// 往前svg图标
var doubleBackwardSvg = _react["default"].createElement("svg", {
  width: "12",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, _react["default"].createElement("g", {
  stroke: "currentColor",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square"
}, _react["default"].createElement("path", {
  d: "M7 12L1 6l6-6"
}), _react["default"].createElement("path", {
  d: "M11 12L5 6l6-6"
}))); // 往前svg图标


var backwardSvg = _react["default"].createElement("svg", {
  width: "8px",
  height: "12px",
  viewBox: "0 0 8 12"
}, _react["default"].createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-1308.000000, -767.000000)",
  opacity: "0.5",
  strokeLinecap: "square"
}, _react["default"].createElement("g", {
  id: "Group-7",
  transform: "translate(1291.000000, 714.000000)",
  stroke: "#3A3B40"
}, _react["default"].createElement("g", {
  id: "Group-4"
}, _react["default"].createElement("polyline", {
  id: "Line-Copy-23",
  transform: "translate(21.000000, 59.000000) scale(-1, 1) rotate(-90.000000) translate(-21.000000, -59.000000) ",
  points: "15 56 21 62 27 56"
}))))); // 往后svg图标


var doubleForwardSvg = _react["default"].createElement("svg", {
  width: "12",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, _react["default"].createElement("g", {
  stroke: "currentColor",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square"
}, _react["default"].createElement("path", {
  d: "M5 12l6-6-6-6"
}), _react["default"].createElement("path", {
  d: "M1 12l6-6-6-6"
}))); // 往后svg图标


var forwardSvg = _react["default"].createElement("svg", {
  width: "8px",
  height: "12px",
  viewBox: "0 0 8 12"
}, _react["default"].createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-1504.000000, -767.000000)",
  opacity: "0.5",
  strokeLinecap: "square"
}, _react["default"].createElement("g", {
  id: "Group-7",
  transform: "translate(1291.000000, 714.000000)",
  stroke: "#3A3B40"
}, _react["default"].createElement("g", {
  id: "Group-4"
}, _react["default"].createElement("polyline", {
  id: "Line-Copy-23",
  transform: "translate(217.000000, 59.000000) rotate(-90.000000) translate(-217.000000, -59.000000) ",
  points: "211 56 217 62 223 56"
})))));

var getTitleLabelComponent = function getTitleLabelComponent() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onShowChooseMonth = props.onShowChooseMonth,
      onShowChooseYear = props.onShowChooseYear,
      year = props.year,
      month = props.month,
      disabled = props.disabled,
      chooseMonth = props.chooseMonth,
      chooseYear = props.chooseYear,
      setLabel = props.setLabel,
      picker = props.picker,
      displayedStartYear = props.displayedStartYear,
      displayedEndYear = props.displayedEndYear;
  var labelType = 'title';

  var getLabel = setLabel || function (type) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var labelResult = [];

    if (data.year) {
      labelResult.push(_react["default"].createElement("a", _extends({}, data.yearProps, {
        key: "spaui-datepicker-set-label-year"
      }), "".concat(data.year, "\u5E74")));
    }

    if (typeof data.month !== 'undefined') {
      labelResult.push(_react["default"].createElement("a", _extends({}, data.monthProps, {
        key: "spaui-datepicker-set-label-month"
      }), "".concat(data.month + 1, "\u6708")));
    }

    return labelResult;
  };

  var yearTitleProps = {};
  var monthTitleProps = {};
  var result = null;

  if (!(0, _spauiUtils.isUndefined)(year) && !disabled && (0, _spauiUtils.isFunction)(onShowChooseYear)) {
    yearTitleProps.onClick = onShowChooseYear;
  }

  if (!(0, _spauiUtils.isUndefined)(month) && !disabled && (0, _spauiUtils.isFunction)(onShowChooseMonth)) {
    monthTitleProps.onClick = onShowChooseMonth;
  }

  if (chooseMonth) {
    result = getLabel(labelType, {
      year: year,
      yearProps: monthTitleProps
    });
  } else if (chooseYear) {
    result = getLabel(labelType, {
      month: month,
      monthProps: yearTitleProps
    });
  } else if (!(0, _spauiUtils.isUndefined)(month)) {
    result = _react["default"].createElement("div", null, getLabel(labelType, {
      year: year,
      yearProps: yearTitleProps,
      month: month,
      monthProps: monthTitleProps
    }));
  } else {
    result = _react["default"].createElement("div", null, getLabel(labelType, {
      year: year,
      yearProps: yearTitleProps
    }));
  }

  if (picker === 'year') {
    result = "".concat(displayedStartYear + 1, "-").concat(displayedEndYear - 1);
  }

  return result;
};
/**
 * @class
 */


var TitlePanel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TitlePanel, _PureComponent);

  function TitlePanel(props) {
    var _this;

    _classCallCheck(this, TitlePanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TitlePanel).call(this, props));
    _this.handleRollClick = _this.handleRollClick.bind(_assertThisInitialized(_this));
    return _this;
  } // 点击左右切换


  _createClass(TitlePanel, [{
    key: "handleRollClick",
    value: function handleRollClick(event, type) {
      var _this$props = this.props,
          year = _this$props.year,
          propsMonth = _this$props.month,
          onChange = _this$props.onChange,
          chooseYear = _this$props.chooseYear,
          chooseMonth = _this$props.chooseMonth,
          picker = _this$props.picker,
          onChangeDisplayedStartYear = _this$props.onChangeDisplayedStartYear;
      var month = (0, _index.toInt)(propsMonth);
      var tempYear = 0;
      var tempMonth = 0; // 年份选择器的左右切换

      if (picker === 'year') {
        onChangeDisplayedStartYear(type);
        return;
      }

      if ((0, _spauiUtils.isFunction)(onChange)) {
        // 切换月份
        if (!chooseYear && !chooseMonth && !(0, _spauiUtils.isUndefined)(propsMonth)) {
          if (type === 'backward') {
            if (month === 0) {
              tempMonth = 11;
              tempYear = year - 1;
            } else {
              tempMonth = month - 1;
              tempYear = year;
            }
          } else {
            if (month === 11) {
              tempMonth = 0;
              tempYear = year + 1;
            } else {
              tempMonth = month + 1;
              tempYear = year;
            }
          }
        } else {
          // 切换年份
          if (type === 'backward') {
            tempYear = year - 1;
          } else {
            tempYear = year + 1;
          }

          tempMonth = propsMonth;
        }

        onChange(event, {
          year: tempYear,
          month: tempMonth
        });
      }
    } // 获取面板对应的年月

  }, {
    key: "getValue",
    value: function getValue() {
      var _this$props2 = this.props,
          startYear = _this$props2.startYear,
          startMonth = _this$props2.startMonth,
          endYear = _this$props2.endYear,
          endMonth = _this$props2.endMonth,
          year = _this$props2.year,
          month = _this$props2.month,
          type = _this$props2.type,
          disabled = _this$props2.disabled;
      var theYear;
      var theMonth;

      if (!disabled) {
        // 当前年份与月份
        if (type === 'single') {
          theYear = year;
          theMonth = month;
        } else if (type === 'start') {
          theYear = startYear;
          theMonth = startMonth;
        } else if (type === 'end') {
          theYear = endYear;
          theMonth = endMonth;
        }
      }

      return {
        year: theYear,
        month: theMonth
      };
    } // 隐藏backward按钮

  }, {
    key: "hideBackward",
    value: function hideBackward() {
      var _this$props3 = this.props,
          startYear = _this$props3.startYear,
          startMonth = _this$props3.startMonth,
          type = _this$props3.type,
          disabled = _this$props3.disabled,
          _this$props3$optional = _this$props3.optionalStartDateData,
          optionalStartDateData = _this$props3$optional === void 0 ? {} : _this$props3$optional,
          chooseYear = _this$props3.chooseYear,
          picker = _this$props3.picker,
          displayedStartYear = _this$props3.displayedStartYear,
          chooseMonth = _this$props3.chooseMonth;
      var optionalStartYear = optionalStartDateData.year,
          optionalStartMonth = optionalStartDateData.month; // 当前年份与月份

      var _this$getValue = this.getValue(),
          theYear = _this$getValue.year,
          theMonth = _this$getValue.month;

      var result = false;

      if (!disabled) {
        if (picker === 'year') {
          if (optionalStartDateData.year <= displayedStartYear) {
            result = false;
          } else {
            result = true;
          }
        } else if ( // 当前年份小于或等于可选年份
        (0, _index.compareDate)({
          year: theYear,
          month: theMonth
        }, {
          year: optionalStartYear,
          month: optionalStartMonth
        }) <= 0) {
          result = true;
        } else {
          // 在选择年份面板时，如果年份与可选年份相等或者年份比可选年份大一年但是当前大月份比可选月份小都不能够往前
          if (chooseYear) {
            if (theYear === optionalStartYear || theYear - 1 === optionalStartYear && theMonth < optionalStartMonth) {
              result = true;
            }
          } // 右边面板的日期小于等于左边的时候，也不能往过去的日期切了


          if (!result && type === 'end') {
            theMonth = theMonth - 1;

            if (theMonth < 0) {
              theMonth += 12;
              theYear = theYear - 1;
            }

            if ((0, _index.compareDate)({
              year: theYear,
              month: theMonth
            }, {
              year: startYear,
              month: startMonth
            }) <= 0) {
              result = true;
            }
          } else if (!result && chooseMonth) {
            // 选择月份时，如果当前面板的前一年最后一个月小于可选日期，那就说明不可选
            if ((0, _index.compareDate)({
              year: theYear - 1,
              month: 11
            }, {
              year: optionalStartYear,
              month: optionalStartMonth
            }) < 0) {
              result = true;
            }
          }
        }
      } else {
        result = true;
      }

      return result;
    } // 是否隐藏forward按钮

  }, {
    key: "hideForward",
    value: function hideForward() {
      var _this$props4 = this.props,
          endYear = _this$props4.endYear,
          endMonth = _this$props4.endMonth,
          type = _this$props4.type,
          picker = _this$props4.picker,
          disabled = _this$props4.disabled,
          _this$props4$optional = _this$props4.optionalEndDateData,
          optionalEndDateData = _this$props4$optional === void 0 ? {} : _this$props4$optional,
          chooseYear = _this$props4.chooseYear,
          _this$props4$hideEndD = _this$props4.hideEndDatePanel,
          hideEndDatePanel = _this$props4$hideEndD === void 0 ? false : _this$props4$hideEndD,
          displayedEndYear = _this$props4.displayedEndYear;
      var optionalEndYear = optionalEndDateData.year,
          optionalEndMonth = optionalEndDateData.month;

      var _this$getValue2 = this.getValue(),
          theYear = _this$getValue2.year,
          theMonth = _this$getValue2.month;

      var result = false;

      if (!disabled) {
        if (picker === 'year') {
          if (displayedEndYear <= optionalEndDateData.year) {
            result = false;
          } else {
            result = true;
          }
        } else if ( // 当前年份大于或等于可选年份
        (0, _index.compareDate)({
          year: theYear,
          month: theMonth
        }, {
          year: optionalEndYear,
          month: optionalEndMonth
        }) >= 0) {
          result = true;
        } else {
          // 在选择年份面板时，如果年份与可选年份相等或者年份比可选年份小一年但是当前大月份比可选月份大都不能够往前
          if (chooseYear) {
            if (theYear === optionalEndYear || theYear + 1 === optionalEndYear && theMonth > optionalEndMonth) {
              result = true;
            }
          } // 左边面板的日期大于等于右边的时候，也不能往未来的日期切了
          // 如果隐藏了结束面板就不需要做对比了


          if (!result && type === 'start' && !hideEndDatePanel) {
            theMonth = theMonth + 1;

            if (theMonth > 11) {
              theMonth -= 12;
              theYear = theYear + 1;
            }

            if ((0, _index.compareDate)({
              year: theYear,
              month: theMonth
            }, {
              year: endYear,
              month: endMonth
            }) >= 0) {
              result = true;
            }
          }
        }
      } else {
        result = true;
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _classNames;

      var _this$props5 = this.props,
          chooseMonth = _this$props5.chooseMonth,
          chooseYear = _this$props5.chooseYear,
          _this$props5$classNam = _this$props5.classNameMap,
          classNameMap = _this$props5$classNam === void 0 ? {} : _this$props5$classNam,
          picker = _this$props5.picker;
      var forwardSvgDom = forwardSvg;
      var backwardSvgDom = backwardSvg; // 年份与月份面板是，左右箭头切换的是年份

      if (chooseMonth || chooseYear) {
        forwardSvgDom = doubleForwardSvg;
        backwardSvgDom = doubleBackwardSvg;
      }

      return _react["default"].createElement("div", {
        className: classNameMap.DatePickerTitlePanelClassName
      }, this.hideBackward() ? null : _react["default"].createElement("div", {
        className: "".concat(classNameMap.DatePickerRollClassName, " ").concat(classNameMap.DatePickerRollBackwardClassName, " spaui-datepicker-pointer"),
        onClick: function onClick(event) {
          return _this2.handleRollClick(event, 'backward');
        }
      }, backwardSvgDom), this.hideForward() ? null : _react["default"].createElement("div", {
        className: "".concat(classNameMap.DatePickerRollClassName, " ").concat(classNameMap.DatePickerRollForwardClassName, " spaui-datepicker-pointer"),
        onClick: function onClick(event) {
          return _this2.handleRollClick(event, 'forward');
        }
      }, forwardSvgDom), _react["default"].createElement("div", {
        className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, classNameMap.DatePickerTitlePanelLabelClassName, picker !== 'year'), _defineProperty(_classNames, classNameMap.DatePickerTitlePanelYearLabelClassName, picker === 'year'), _classNames))
      }, getTitleLabelComponent(this.props)));
    }
  }]);

  return TitlePanel;
}(_react.PureComponent);

_defineProperty(TitlePanel, "propTypes", {
  type: _spauiUtils.PropTypes.string,
  disabled: _spauiUtils.PropTypes.bool,
  chooseMonth: _spauiUtils.PropTypes.bool,
  chooseYear: _spauiUtils.PropTypes.bool,
  year: _spauiUtils.PropTypes.number,
  month: _spauiUtils.PropTypes.number,
  startYear: _spauiUtils.PropTypes.number,
  startMonth: _spauiUtils.PropTypes.number,
  endYear: _spauiUtils.PropTypes.number,
  endMonth: _spauiUtils.PropTypes.number,
  onShowChooseMonth: _spauiUtils.PropTypes.func,
  onShowChooseYear: _spauiUtils.PropTypes.func,
  onChange: _spauiUtils.PropTypes.func
});

_defineProperty(TitlePanel, "defaultProps", {
  type: '',
  year: 0,
  chooseMonth: false,
  chooseYear: false,
  startYear: 0,
  startMonth: 0,
  endYear: 0,
  endMonth: 0,
  disabled: false
});

var _default = TitlePanel;
exports["default"] = _default;